import { render, staticRenderFns } from "./AppUpcomingEvents.vue?vue&type=template&id=3800e3d6"
import script from "./AppUpcomingEvents.vue?vue&type=script&lang=js"
export * from "./AppUpcomingEvents.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports